import * as $ from 'jquery';
import { Observable } from 'rxjs/Observable';
import { fromEvent } from 'rxjs/observable/fromEvent'
//import 'rxjs/add/observable/fromEvent';
import { debounceTime } from 'rxjs/operators';


export class ResizeService {

    public static subscribeStream(callback) {
        if (!ResizeService.resize$)
            ResizeService.resize$ = fromEvent(($(window) as any), 'resize').pipe(debounceTime(500));//.filter( () => {
        //     let ww = $(window).width();
        //     let r = ww == ResizeService.windowWidth;
        //     ResizeService.windowWidth = ww;
        //     return r;
        // }).share();
        ResizeService.resize$.subscribe(callback);
    }

    private static windowWidth = 0;

    static resize$;

}